document.addEventListener('DOMContentLoaded', () => {
	const tooltip = document.createElement('div');
	tooltip.className = 'global-floating-tooltip';
	document.body.appendChild(tooltip);

	Object.assign(tooltip.style, {
		position: 'fixed',
		zIndex: 999999,
		pointerEvents: 'none',
	});

	document.querySelectorAll('.info-icon-hover').forEach(container => {
		const icon = container.querySelector('.wp-rich-text-font-awesome-icon');
		const tooltipText = container.getAttribute('data-tooltip');
		if (!icon || !tooltipText) return;

		icon.addEventListener('mouseenter', () => {
			tooltip.textContent = tooltipText;
			tooltip.style.top = '-9999px';
			tooltip.style.left = '-9999px';
			tooltip.classList.add('visible');

			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					const iconRect = container.getBoundingClientRect();
					const tooltipRect = tooltip.getBoundingClientRect();

					const spaceAbove = iconRect.top;
					const shouldFlip = tooltipRect.height + 12 > spaceAbove;

					const top = shouldFlip
						? iconRect.bottom + 6
						: iconRect.top - tooltipRect.height - 6;

					const left = iconRect.left + iconRect.width / 2 - tooltipRect.width / 2;
					const clampedLeft = Math.max(8, Math.min(left, window.innerWidth - tooltipRect.width - 8));

					tooltip.style.top = `${top}px`;
					tooltip.style.left = `${clampedLeft}px`;
					tooltip.classList.toggle('flipped', shouldFlip);

					// Calculate arrow position based on icon center relative to tooltip
					const iconCenterX = iconRect.left + iconRect.width / 2;
					const tooltipLeftEdge = clampedLeft;
					const arrowLeftPercentage = ((iconCenterX - tooltipLeftEdge) / tooltipRect.width) * 100;
					
					// Clamp arrow position to stay within tooltip bounds (with some padding)
					const clampedArrowLeft = Math.max(10, Math.min(90, arrowLeftPercentage));
					
					// Apply the calculated arrow position
					tooltip.style.setProperty('--arrow-left', `${clampedArrowLeft}%`);
				});
			});
		});

		icon.addEventListener('mouseleave', () => {
			tooltip.classList.remove('visible');
		});
	});
});
